import { client } from './client'
import { getCsrf, getCookie } from './authentication'
import { CustomError } from '../CustomError'
import { CSRF_TOKEN_NAME } from '@/constants'

export const createDocumentVersionSessionEvent = async (
  documentVersionSessionId: string,
  values: {
    document_page_id: string
    button_label: string
    json_data: any
  },
) => {
  await getCsrf()
  const resp = await client.POST(
    '/api/v1/projects/{document_version_session_id}/document_version_session_events',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_version_session_id: documentVersionSessionId,
        },
      },
      body: values,
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to create document-version session event'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const getDocumentVersionSessionEvent = async (
  documentVersionSessionEventId: string,
) => {
  const resp = await client.GET(
    '/api/v1/projects/document_version_session_events/{document_version_session_event_id}',
    {
      params: {
        path: {
          document_version_session_event_id: documentVersionSessionEventId,
        },
      },
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to get document-version session event'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const updateDocumentVersionSessionEvent = async (
  documentVersionSessionEventId: string,
  values: {
    json_data: any
    completed: string
  },
) => {
  await getCsrf()
  const resp = await client.PUT(
    '/api/v1/projects/document_version_session_events/{document_version_session_event_id}',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_version_session_event_id: documentVersionSessionEventId,
        },
      },
      body: values,
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to update document-version session event'
    throw new CustomError(resp, message)
  }

  return resp.data
}
